(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  function mount(track, previous, next) {
    if (controllers.has(track)) return;
    const originals = [...track.children], count = originals.length;
    if (count < 2) return;
    const events = new AbortController(), options = {signal: events.signal};
    const clone = card => {
      const copy = card.cloneNode(true);
      copy.dataset.carouselClone = '';
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('button,a,[tabindex]').forEach(el => el.tabIndex = -1);
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      return copy;
    };
    track.prepend(...originals.map(clone)); track.append(...originals.map(clone));
    const cards = [...track.children];
    const imageObserver = new IntersectionObserver(entries => {
      entries.forEach(({target, isIntersecting}) => {
        if (!isIntersecting) return;
        if (target.dataset.srcset) target.srcset = target.dataset.srcset;
        target.src = target.dataset.src;
        delete target.dataset.src;delete target.dataset.srcset;
        imageObserver.unobserve(target);
      });
    }, {rootMargin:'400px 300px'});
    track.querySelectorAll('img[data-src]').forEach(img => imageObserver.observe(img));

    let index = count, frame = 0, timer = 0, settle = 0, stopped = false, started = false, inView = false, dragging = null, suppressClick = false, moving = false, touching = false;
    const step = () => cards[1].offsetLeft - cards[0].offsetLeft;
    const position = i => cards[i].offsetLeft - cards[0].offsetLeft;
    const paint = () => {
      if (!track.classList.contains('customer-gallery-track')) return;
      const distance = step();
      if (!distance) return;
      const clearZone = matchMedia('(max-width:767px)').matches ? .12 : 0;
      cards.forEach((card,i) => {
        const offset = Math.abs(track.scrollLeft - position(i)) / distance;
        const fraction = Math.min(1, Math.max(0, offset - clearZone) / (1 - clearZone));
        card.style.filter = `blur(${2*fraction}px) brightness(${1-.18*fraction})`;
      });
    };
    const mark = () => { if(track.classList.contains('customer-gallery-track')) cards.forEach((card,i)=>card.classList.toggle('is-current',i===index)); paint(); track.dataset.selected = String(((index % count) + count) % count + 1); track.dataset.autoplay = stopped ? 'stopped' : motion.matches ? 'reduced' : started ? 'active' : 'waiting'; };
    const normalize = () => {
      index = Math.round(track.scrollLeft / step());
      const wrapped = count + ((index % count) + count) % count;
      if (wrapped !== index) { index = wrapped; track.scrollLeft = position(index); }
      mark();
    };
    const cancel = () => { cancelAnimationFrame(frame); clearTimeout(timer); clearTimeout(settle); moving = false; track.style.scrollSnapType = ''; };
    const stop = () => { stopped = true; cancel(); track.setAttribute('aria-live','polite'); mark(); };
    function animate(target, duration, done) {
      cancelAnimationFrame(frame); clearTimeout(settle);
      moving = true; track.style.scrollSnapType = 'none';
      const from = track.scrollLeft, to = position(target), start = performance.now();
      const tick = now => {
        const progress = Math.min(1, (now - start) / duration);
        const eased = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
        track.scrollLeft = from + (to - from) * eased;
        if (progress < 1) frame = requestAnimationFrame(tick);
        else { index = target; normalize(); track.style.scrollSnapType = ''; moving = false; done?.(); }
      };
      if (motion.matches) { track.scrollLeft = to; index = target; normalize(); track.style.scrollSnapType = ''; moving = false; done?.(); }
      else frame = requestAnimationFrame(tick);
    }
    const schedule = () => {
      clearTimeout(timer);
      if (stopped || motion.matches || !inView || document.hidden || !started) return;
      timer = setTimeout(() => animate(index + 1, 420, schedule), 3000);
    };
    const manual = delta => { stop(); normalize(); animate(index + delta, 360); };
    previous?.addEventListener('click', () => manual(-1), options);
    next?.addEventListener('click', () => manual(1), options);
    track.addEventListener('keydown', e => { if (['ArrowLeft','ArrowRight'].includes(e.key)) { e.preventDefault(); manual(e.key === 'ArrowRight' ? 1 : -1); } }, options);
    track.addEventListener('wheel', e => { if (Math.abs(e.deltaX) > 0 || e.shiftKey) stop(); }, {...options, passive:true});
    track.addEventListener('pointerdown', e => {
      if (e.button !== 0) return;
      stop(); suppressClick = false;
      if (e.pointerType === 'mouse') dragging = {x:e.clientX, left:track.scrollLeft, id:e.pointerId};
    }, options);
    track.addEventListener('pointermove', e => {
      if (!dragging) return;
      const distance = e.clientX - dragging.x;
      if (Math.abs(distance) > 6 || suppressClick) { suppressClick = true; track.setPointerCapture(e.pointerId); track.style.scrollSnapType = 'none'; track.scrollLeft = dragging.left - distance; }
    }, options);
    const release = () => {
      if (!dragging) return;
      dragging = null;
      if (suppressClick) { index = Math.round(track.scrollLeft / step()); animate(index, 220); }
    };
    track.addEventListener('pointerup', release, options); track.addEventListener('pointercancel', release, options);
    track.addEventListener('dragstart', e => e.preventDefault(), options);
    track.addEventListener('click', e => { if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; return; } const photo=e.target.closest('[data-carousel-clone] [data-photo]'); if(photo) originals.find(card=>card.querySelector('[data-photo]')?.dataset.photo===photo.dataset.photo)?.querySelector('[data-photo]').click(); }, {...options, capture:true});
    track.addEventListener('touchstart', () => { touching = true; stop(); }, {...options, passive:true});
    track.addEventListener('touchend', () => { touching = false; }, {...options, passive:true});
    track.addEventListener('touchcancel', () => { touching = false; }, {...options, passive:true});
    track.addEventListener('scrollend', () => { if (!moving && !dragging && !touching) normalize(); }, options);
    track.addEventListener('scroll', () => { paint(); if (moving || dragging || touching || 'onscrollend' in track) return; clearTimeout(settle); settle = setTimeout(normalize, 400); }, {...options, passive:true});
    track.addEventListener('focusin', () => { if (!stopped) stop(); }, options);
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      if (!inView) { clearTimeout(timer); return; }
      if (!started) {
        started = true;
        if (!stopped && !motion.matches) animate(count + Math.min(4,count-1), 1600, schedule);
        else mark();
      } else if (!moving) schedule();
    }, {threshold:.25});
    observer.observe(track);
    let lastWidth = track.clientWidth;
    const resize = new ResizeObserver(() => { if(lastWidth === track.clientWidth) return; lastWidth = track.clientWidth; cancelAnimationFrame(frame); moving = false; track.style.scrollSnapType = 'none'; track.scrollLeft = position(index); track.style.scrollSnapType = ''; schedule(); });
    resize.observe(track);
    document.addEventListener('visibilitychange', () => { if(document.hidden) { cancel(); normalize(); } else schedule(); }, options);
    addEventListener('pagehide', () => { cancel(); normalize(); }, options);
    addEventListener('pageshow', schedule, options);
    motion.addEventListener('change', () => { cancel(); normalize(); schedule(); mark(); }, options);
    track.style.scrollSnapType = 'none'; track.scrollLeft = position(index); track.style.scrollSnapType = ''; mark();
    controllers.set(track, () => { cancel(); observer.disconnect(); imageObserver.disconnect(); resize.disconnect(); events.abort(); track.querySelectorAll('[data-carousel-clone]').forEach(el => el.remove()); });
  }
  function init() {
    document.querySelectorAll('.review-grid').forEach(track => mount(track, track.parentElement.querySelector('[data-review-prev]'), track.parentElement.querySelector('[data-review-next]')));
    document.querySelectorAll('.customer-gallery-track').forEach(track => mount(track, track.parentElement.querySelector('.customer-gallery-prev'), track.parentElement.querySelector('.customer-gallery-next')));
  }
  init();
  addEventListener('pagehide', e => { if(!e.persisted) { controllers.forEach(cleanup => cleanup()); controllers.clear(); } });
  addEventListener('pageshow', init);
  document.addEventListener('shopify:section:unload', e => { controllers.forEach((cleanup,track) => { if(e.target.contains(track)) {cleanup();controllers.delete(track);} }); });
  document.addEventListener('shopify:section:load', init);
})();
